import {
  GET_USER_TRANSACTION_ERROR,
  GET_USER_TRANSACTION_START,
  GET_USER_TRANSACTION_SUCCESS,
} from 'constants/action-types/user/getUserTransactions';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_USER_TRANSACTION_START:
      return {
        ...state,
        getTransactions: {
          ...state.getTransactions,
          loading: true,
          error: null,
          data: [],
          meta: {},
        },
      };
    case GET_USER_TRANSACTION_SUCCESS:
      return {
        ...state,
        getTransactions: {
          ...state.getTransactions,
          loading: false,
          meta: payload.meta,
          data: payload.data,
        },
      };
    case GET_USER_TRANSACTION_ERROR:
      return {
        ...state,
        getTransactions: {
          ...state.getTransactions,
          error: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
